import { getCareItemAnimationName } from 'src/lib/ui/config/buruburu';
import { CareItem, DuoItem } from 'src/replicant/buruburu/care/care.ruleset';
import { CareItemEntity, fromEntityId } from '../logic/EntityManager';

export class ItemAppearanceController {
  constructor(private entity: CareItemEntity) {}

  public animate() {
    this.entity.play(
      getCareItemAnimationName(
        fromEntityId(this.entity.entityId).id as Exclude<
          CareItem['id'],
          DuoItem
        >,
      ),
      () => {
        // Stop item on the last animation frame
        this.entity.goto(this.entity.frameCount - 1);
      },
    );
  }
}
